<template>
  <div>
    <v-container>
      <v-row>
        <v-col cols="3">
          <v-text-field
            v-model.number="editedItem.fiscalYear"
            id="saiMonthlyTransItemFYText"
            class="sai-monthly-trans-item-fy-text"
            label="Fiscal Year"
            readonly
          ></v-text-field>
        </v-col>
        <v-col cols="3">
          <v-text-field
            v-model="editedItem.month"
            id="saiMonthlySummaryItemMonthText"
            class="sai-monthly-summary-item-month-text"
            label="Month"
            readonly
          ></v-text-field>
        </v-col>
        <v-col cols="3">
          <v-text-field
            v-model="editedItem.year"
            id="saiMonthlySummaryItemYearText"
            class="sai-monthly-summary-item-year-text"
            label="Year"
            readonly
          ></v-text-field>
        </v-col>
        <v-col cols="3">
          <ClarionDateControl
            v-model="editedItem.dateSentToSAI"
            :isToggle="false"
            label="Date Sent to SAI"
          />
        </v-col>
      </v-row>
      <v-row class="d-flex align-end">
        <v-col cols="2">
          <v-checkbox
            v-model="editedItem.isLocked"
            id="saiMonthlySummaryItemDailyLockedCheckbox"
            class="sai-monthly-summary-item-locked-checkbox"
            label="Locked"
          ></v-checkbox>
        </v-col>
        <v-col cols="2">
          <v-checkbox
            v-model="editedItem.isUnUsable"
            id="saiMonthlySummaryItemDailyUnUsableCheckbox"
            class="sai-monthly-summary-item-un-usable-checkbox"
            label="Un Usable"
            readonly
          ></v-checkbox>
        </v-col>
        <v-col cols="5">
          <v-textarea
            v-model="editedItem.comment"
            id="saiMonthlySummaryItemFundSelect"
            class="sai-monthly-summary-item-comment-textarea"
            label="Comment"
            rows="2"
          ></v-textarea>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3">
          <v-text-field
            v-model="editedItem.summaryDetailsGLFunds"
            id="saiMonthlySummaryItemSumOfGLText"
            class="sai-monthly-summary-item-sum-of-gl-text"
            label="Sum of GL"
            autofocus
            readonly
            @focus="roundAmount"
            @blur="roundAmount"
          ></v-text-field>
        </v-col>
        <v-col cols="3">
          <v-text-field
            v-model="editedItem.summaryDetailsGLBanks"
            id="saiMonthlySummaryItemSumOfBanksText"
            class="sai-monthly-summary-item-sum-of-banks-text"
            label="Sum of Banks"
            @blur="roundAmount"
            readonly
          ></v-text-field>
        </v-col>
        <v-col cols="3">
          <v-text-field
            v-model="editedItem.bankTotalFromGL"
            id="saiMonthlySummaryItemGLBankTotalsText"
            class="sai-monthly-summary-item-gl-bank-totals-text"
            label="GL Bank Totals"
            @blur="roundAmount"
            readonly
          ></v-text-field>
        </v-col>
        <v-col cols="3">
          <v-text-field
            v-model="editedItem.fundTotalFromGL"
            id="saiMonthlySummaryItemFundTotalsText"
            class="sai-monthly-summary-fund-totals-text"
            label="Fund Totals"
            @blur="roundAmount"
            readonly
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3">
          <v-text-field
            v-model="editedItem.odTotalMonthlySummary"
            id="saiMonthlySummaryItemODTotalText"
            class="sai-monthly-summary-od-total-text"
            label="OD Total"
            @blur="roundAmount"
            readonly
          ></v-text-field>
        </v-col>
        <v-col cols="3">
          <v-text-field
            v-model="editedItem.glBankMonthlySummary"
            id="saiMonthlySummaryItemODGLBankText"
            class="sai-monthly-summary-item-od-gl-bank-text"
            label="OD GL Bank"
            @blur="roundAmount"
            readonly
          ></v-text-field>
        </v-col>
        <v-col cols="3">
          <v-text-field
            v-model="editedItem.glFundMonthlySummary"
            id="saiMonthlySummaryItemODGLFundText"
            class="sai-monthly-summary-item-od-gl-fund-text"
            label="OD GL Fund"
            @blur="roundAmount"
            readonly
          ></v-text-field>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import { amountFormat, amountToNumber } from '../../../../util/shared/vue-global';
import ClarionDateControl from '../../../common/ClarionDateControl.vue';

const amountFields = [
  'summaryDetailsGLFunds',
  'summaryDetailsGLBanks',
  'bankTotalFromGL',
  'fundTotalFromGL',
  'odTotalMonthlySummary',
  'glBankMonthlySummary',
  'glFundMonthlySummary',
];

export default {
  name: 'SaiMonthlySummaryEditedItem',
  components: {
    ClarionDateControl,
  },
  props: {
    baseCrudKey: {
      type: String,
      default: 'saiMonthlySummary-dialog',
    },
  },
  created() {
  },
  computed: {
    ...mapGetters('base/crud', [
      'item',
      'items',
      'index',
      'isVisible',
    ]),
    editedItem: {
      get() {
        return this.item(this.baseCrudKey);
      },
      set(value) {
        this.setItem([this.baseCrudKey, value]);
      },
    },
  },
  methods: {
    ...mapMutations('base/crud', [
      'setItem',
    ]),
    roundAmount() {
      return amountFields.forEach((f) => {
        this.editedItem[f] = amountFormat(amountToNumber(this.editedItem[f]));
      });
    },
  },
};
</script>
